<!-- Main Footer -->
<footer class="main-footer text-center">
  <!-- Default to the left -->
  <!-- <strong>Copyright &copy; {{ anio }} <a href="http://www.bcmsa.com/">BCM v{{appVersion | async}}</a></strong> - {{lastSyncData}} -->
  <strong
    >Copyright &copy; {{ anio }} <a href="">TCM System {{ appVersion | async }}</a></strong
  >
  - {{ lastSyncData }}
</footer>
